module.exports = __webpack_public_path__ + "static/media/draw-gift-card.295bf947.svg";